import initialState from './AdvertiserInitialState';
import reducers from './AdvertiserReducer';

export default {
  initialState,
  reducers,
};
